import { createElement as rc, useMemo } from 'react';
import { styled, MenuSubMenu, fromTheme, View, Text, Icon } from 'lib_ui-primitives';
import MenuContext from './MenuContext';
Object.defineProperty(MenuSubMenu, '_reactMenu', { value: 'MenuSubMenu', writable: false });

const MenuText = styled(Text)`
    ${fromTheme('menu', 'menuItem', 'defaultFont')}
`;

const LeftToRight = styled(View)`
    flex-direction: row;
    gap: ${fromTheme('menu', 'menuItem', 'iconTextGap')};
`;

export default function SubMenu(props) {
    const { children, actionPayload, ...otherProps } = props;

    const label = useMemo(() => {
        const iconName = props.hNode?.iconName;
        return rc(
            LeftToRight,
            null,
            iconName && rc(Icon, { name: iconName, size: 'md', children: iconName }),
            rc(MenuText, { ...otherProps }, props.hNode?.title ?? '')
        );
    }, [otherProps, props.hNode?.iconName, props.hNode?.title]);

    // Wrap children in MenuContext to provide menu info including actionPayload from parent MenuButton
    const contextValue = useMemo(() => ({
        isInsideMenu: true,
        actionPayload
    }), [actionPayload]);

    const wrappedChildren = rc(MenuContext.Provider, { value: contextValue }, children);

    return rc(MenuSubMenu, { ...props, label }, wrappedChildren);
}
